import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SendIdService {

  private idSource = new BehaviorSubject<number | null>(null);
  public currentId = this.idSource.asObservable();
  public id?: number;

  constructor() { }

  SendId(id: number) {
    this.id = id;
    this.idSource.next(id);
  }

}
